import { PurseType } from 'types/enums';

export const fiatCurrencyList: PurseType[] = [
    PurseType.ZWL,
    PurseType.TND,
    PurseType.XAF,
    PurseType.TWD,
    PurseType.TW13,
    PurseType.USD,
    PurseType.UAH,
    PurseType.EUR,
    PurseType.INR,
    PurseType.BRL,
    PurseType.DEMO,
    PurseType.KZT,
    PurseType.VND,
    PurseType.VND1,
    PurseType.UZS,
    PurseType.IDR,
    PurseType.IDR1,
    PurseType.AZN,
    PurseType.KGS,
    PurseType.BDT,
    PurseType.PKR,
    PurseType.RUB,
    PurseType.CLP,
    PurseType.PEN,
    PurseType.COP,
    PurseType.MXN,
    PurseType.ARS,
    PurseType.BOB,
    PurseType.CRC,
    PurseType.SVC,
    PurseType.GTQ,
    PurseType.NIO,
    PurseType.PAB,
    PurseType.PYG,
    PurseType.UYU,
    PurseType.CAD,
    PurseType.CZK,
    PurseType.ZAR,
    PurseType.BGN,
    PurseType.DKK,
    PurseType.RON,
    PurseType.AUD,
    PurseType.NZD,
    PurseType.CHF,
    PurseType.NOK,
    PurseType.HUF,
    PurseType.TRY,
    PurseType.PLN,
    PurseType.GBP,
    PurseType.NGN,
    PurseType.JPY,
    PurseType.SEK,
    PurseType.ZMW,
    PurseType.TZS,
    PurseType.GHS,
    PurseType.XOF,
    PurseType.VEF,
    PurseType.VES,
    PurseType.SGD,
    PurseType.HRK,
    PurseType.KRW,
    PurseType.KES,
    PurseType.BAM,
    PurseType.RSD,
    PurseType.AED,
    PurseType.AFN,
    PurseType.ALL,
    PurseType.AMD,
    PurseType.ANG,
    PurseType.AOA,
    PurseType.AWG,
    PurseType.BBD,
    PurseType.BHD,
    PurseType.BIF,
    PurseType.BMD,
    PurseType.BND,
    PurseType.BOV,
    PurseType.BSD,
    PurseType.BTN,
    PurseType.BWP,
    PurseType.BYN,
    PurseType.BZD,
    PurseType.CDF,
    PurseType.CHW,
    PurseType.CLF,
    PurseType.CUP,
    PurseType.CVE,
    PurseType.DJF,
    PurseType.DOP,
    PurseType.DZD,
    PurseType.EGP,
    PurseType.ERN,
    PurseType.ETB,
    PurseType.FJD,
    PurseType.FKP,
    PurseType.GEL,
    PurseType.GMD,
    PurseType.GNF,
    PurseType.GYD,
    PurseType.HKD,
    PurseType.HNL,
    PurseType.HTG,
    PurseType.ILS,
    PurseType.IQD,
    PurseType.IRR,
    PurseType.IRT,
    PurseType.ISK,
    PurseType.JMD,
    PurseType.JOD,
    PurseType.KHR,
    PurseType.KMF,
    PurseType.KPW,
    PurseType.KWD,
    PurseType.KYD,
    PurseType.LAK,
    PurseType.LBP,
    PurseType.LKR,
    PurseType.LRD,
    PurseType.LSL,
    PurseType.LYD,
    PurseType.MAD,
    PurseType.MDL,
    PurseType.MGA,
    PurseType.MKD,
    PurseType.MMK,
    PurseType.MNT,
    PurseType.MOP,
    PurseType.MRU,
    PurseType.MUR,
    PurseType.MVR,
    PurseType.MWK,
    PurseType.MYR,
    PurseType.MZN,
    PurseType.NAD,
    PurseType.NPR,
    PurseType.OMR,
    PurseType.PGK,
    PurseType.PHP,
    PurseType.QAR,
    PurseType.CNY,
    PurseType.RWF,
    PurseType.SAR,
    PurseType.SBD,
    PurseType.SCR,
    PurseType.SDG,
    PurseType.SHP,
    PurseType.SLE,
    PurseType.SLL,
    PurseType.SOS,
    PurseType.SRD,
    PurseType.SSP,
    PurseType.SYP,
    PurseType.SZL,
    PurseType.GIP,
    PurseType.UGX,
    PurseType.GMS,
    PurseType.THB,
    PurseType.R$,
    PurseType.DLS,
];

export const supportedCurrency = (currency: PurseType): PurseType =>
    fiatCurrencyList.includes(currency) ? currency : PurseType.USD;

const singFiatCurrency = (currency: PurseType): string => {
    currency = supportedCurrency(currency);

    switch (currency) {
        case PurseType.XAF:
            return 'XAF';
        case PurseType.TND:
            return 'TND';
        case PurseType.ZWL:
            return 'ZWL';
        case PurseType.TWD:
            return 'TWD';
        case PurseType.TW13:
            return 'TW13';
        case PurseType.USD:
            return '$';
        case PurseType.UAH:
            return '₴';
        case PurseType.EUR:
            return '€';
        case PurseType.RUB:
            return '₽';
        case PurseType.INR:
            return '₹';
        case PurseType.BRL:
            return 'R$';
        case PurseType.KZT:
            return '₸';
        case PurseType.VND:
            return '₫';
        case PurseType.VND1:
            return 'VND(K)';
        case PurseType.UZS:
            return "So'm";
        case PurseType.IDR:
            return 'Rp';
        case PurseType.IDR1:
        return 'IDR(K)';
        case PurseType.AZN:
            return '₼';
        case PurseType.KGS:
            return 'с';
        case PurseType.BDT:
            return '৳';
        case PurseType.PKR:
            return 'Rs';
        case PurseType.PEN:
            return 'P$';
        case PurseType.DEMO:
            return 'D';
        case PurseType.CLP:
            return 'C$';
        case PurseType.COP:
            return 'C$';
        case PurseType.MXN:
            return 'M$';
        case PurseType.CAD:
            return 'C$';
        case PurseType.CZK:
            return 'Kč';
        case PurseType.ZAR:
            return 'R';
        case PurseType.BGN:
            return 'лв';
        case PurseType.DKK:
            return 'kr';
        case PurseType.RON:
            return 'lei';
        case PurseType.AUD:
            return 'A$';
        case PurseType.NZD:
            return 'N$';
        case PurseType.CHF:
            return '₣';
        case PurseType.NOK:
            return 'kr';
        case PurseType.HUF:
            return 'Ft';
        case PurseType.TRY:
            return '₺';
        case PurseType.PLN:
            return 'zł';
        case PurseType.GBP:
            return '£';
        case PurseType.NGN:
            return '₦';
        case PurseType.JPY:
            return '¥';
        case PurseType.SEK:
            return 'kr';
        case PurseType.ZMW:
            return 'ZK';
        case PurseType.TZS:
            return 'TSh';
        case PurseType.GHS:
            return 'GH¢';
        case PurseType.XOF:
            return 'CFA';
        case PurseType.VEF:
            return 'Bs';
        case PurseType.VES:
            return 'VES';
        case PurseType.SGD:
            return 'S$';
        case PurseType.HRK:
            return 'kn';
        case PurseType.KRW:
            return '₩';
        case PurseType.KES:
            return 'KES';
        case PurseType.BAM:
            return 'BA';
        case PurseType.RSD:
            return 'DIN';
        case PurseType.AED:
            return 'د.إ';
        case PurseType.AFN:
            return '؋';
        case PurseType.ALL:
            return 'L';
        case PurseType.AMD:
            return '֏';
        case PurseType.ANG:
            return 'ƒ';
        case PurseType.AOA:
            return 'Kz';
        case PurseType.AWG:
            return 'AWG';
        case PurseType.BBD:
            return 'Bds$';
        case PurseType.BHD:
            return 'BD';
        case PurseType.BIF:
            return 'BIF';
        case PurseType.BMD:
            return '$';
        case PurseType.BND:
            return 'B$';
        case PurseType.BOV:
            return 'BOV';
        case PurseType.BSD:
            return 'B$';
        case PurseType.BTN:
            return 'BTN';
        case PurseType.BWP:
            return 'P';
        case PurseType.BYN:
            return 'BYN';
        case PurseType.BZD:
            return '$';
        case PurseType.CDF:
            return 'FC';
        case PurseType.CHW:
            return 'CHW';
        case PurseType.CLF:
            return 'CLF';
        case PurseType.CUP:
            return 'CUP';
        case PurseType.CVE:
            return 'CVE';
        case PurseType.DJF:
            return 'Fdj';
        case PurseType.DOP:
            return 'DOP';
        case PurseType.DZD:
            return 'دج';
        case PurseType.EGP:
            return 'E£';
        case PurseType.ERN:
            return 'Nkf';
        case PurseType.ETB:
            return 'ETB';
        case PurseType.FJD:
            return 'FJ$';
        case PurseType.FKP:
            return 'FK£';
        case PurseType.GEL:
            return 'GEL';
        case PurseType.GMD:
            return 'D';
        case PurseType.GNF:
            return 'FG';
        case PurseType.GYD:
            return 'G$';
        case PurseType.HKD:
            return 'HK$';
        case PurseType.HNL:
            return 'HNL';
        case PurseType.HTG:
            return 'HTG';
        case PurseType.ILS:
            return '₪';
        case PurseType.IQD:
            return 'ع.د';
        case PurseType.IRR:
            return 'IRR';
        case PurseType.ISK:
            return 'ISK';
        case PurseType.JMD:
            return 'J$';
        case PurseType.JOD:
            return 'JOD';
        case PurseType.KHR:
            return 'KHR';
        case PurseType.KMF:
            return 'CF';
        case PurseType.KPW:
            return '₩';
        case PurseType.KWD:
            return 'د.ك';
        case PurseType.KYD:
            return 'CI';
        case PurseType.LAK:
            return '₭';
        case PurseType.LBP:
            return 'L£';
        case PurseType.LKR:
            return 'රු';
        case PurseType.LRD:
            return 'L$';
        case PurseType.LSL:
            return 'LSL';
        case PurseType.LYD:
            return 'ل.د';
        case PurseType.MAD:
            return 'د.م.';
        case PurseType.MDL:
            return 'L';
        case PurseType.MGA:
            return 'MGA';
        case PurseType.MKD:
            return 'den';
        case PurseType.MMK:
            return 'MMK';
        case PurseType.MNT:
            return '₮';
        case PurseType.MOP:
            return '$';
        case PurseType.MRU:
            return 'UM';
        case PurseType.MUR:
            return 'Re';
        case PurseType.MVR:
            return 'Rf';
        case PurseType.MWK:
            return 'MK';
        case PurseType.MYR:
            return 'RM';
        case PurseType.MZN:
            return 'MT';
        case PurseType.NAD:
            return 'N$';
        case PurseType.NPR:
            return 'NPR';
        case PurseType.OMR:
            return 'OMR';
        case PurseType.PGK:
            return 'K';
        case PurseType.PHP:
            return '₱';
        case PurseType.QAR:
            return 'QAR';
        case PurseType.CNY:
            return '¥';
        case PurseType.RWF:
            return 'RF';
        case PurseType.SAR:
            return 'SAR';
        case PurseType.SBD:
            return 'SI$';
        case PurseType.SCR:
            return 'SCR';
        case PurseType.SDG:
            return 'SDG';
        case PurseType.SHP:
            return 'SHP';
        case PurseType.SLE:
            return 'Le';
        case PurseType.SLL:
            return 'Le';
        case PurseType.SOS:
            return 'SOS';
        case PurseType.SRD:
            return '$';
        case PurseType.SSP:
            return 'SSP';
        case PurseType.SYP:
            return 'SYP';
        case PurseType.SZL:
            return 'SZL';
        case PurseType.GIP:
            return '£';
        case PurseType.UGX:
            return 'UGX';
        case PurseType.GMS:
            return 'GMS';
        case PurseType.DLS:
            return 'DLS';
        default:
            return currency;
    }
};

export default singFiatCurrency;
